import i18n, { type BackendModule } from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

export const locales = ['zh', 'en', 'ja', 'ko'] as const
export type Locale = (typeof locales)[number]
export const defaultLocale: Locale = 'zh'

export const localeNames: Record<Locale, string> = {
  zh: '中文',
  en: 'English',
  ja: '日本語',
  ko: '한국어',
}

const messageLoaders: Record<Locale, () => Promise<{ default: Record<string, unknown> }>> = {
  zh: () => import('@/messages/zh.json'),
  en: () => import('@/messages/en.json'),
  ja: () => import('@/messages/ja.json'),
  ko: () => import('@/messages/ko.json'),
}

const messageBackend: BackendModule = {
  type: 'backend',
  init: () => undefined,
  read(language, namespace, callback) {
    const locale = language.split('-')[0] as Locale
    if (namespace !== 'translation' || !locales.includes(locale)) {
      callback(new Error(`Unsupported translation resource: ${language}/${namespace}`), false)
      return
    }
    messageLoaders[locale]()
      .then((module) => callback(null, module.default))
      .catch((error: unknown) => callback(error instanceof Error ? error : new Error(String(error)), false))
  },
}

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(messageBackend)
  .init({
    fallbackLng: defaultLocale,
    supportedLngs: locales,
    load: 'languageOnly',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['cookie', 'navigator'],
      lookupCookie: 'LOCALE',
      caches: ['cookie'],
      cookieMinutes: 60 * 24 * 365,
    },
  })

export default i18n
